import { Component } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { NavController, NavParams, ViewController, AlertController } from 'ionic-angular';
import { DateValidator } from  '../../validators/date';
import { Items } from '../../providers/providers';
import { UserData } from '../../models/user';
import { User } from '../../providers/user';
import { Practice } from '../../models/practice';
import * as moment from 'moment';
import { Grouping } from '../../models/groupings';
import { IonicSelectableModule } from 'ionic-selectable';

@Component({
  selector: 'page-client-create',
  templateUrl: 'client-create.html'
})
export class ClientCreatePage {
  
  client: { first_name: string, last_name: string, email: string, date_of_birth: string, sex_id: string, inactive: string, assigned_users:any[], assigned_groups:any[]} = {
    first_name: '',
    last_name: '',
    email: '',
    date_of_birth: '',
    sex_id:'',
    inactive: '',
    assigned_users:[],
    assigned_groups:[]
  };

  submitClient: boolean = false;
  isReadyToSave: boolean;
  isEditClient: boolean = false;
  isVisible: boolean = false;
  practices:any[];
  practiceData: Practice;
  practices_array:any[];
  groupings: any[];
  groupings_array: any[];
  showClientGroups: boolean = false;
  showClientUsers: boolean = false;
  groupSelected: any[];
  userSelected: any[];
  current: any[];

  item: any;

  public form: FormGroup;

  constructor(public navCtrl: NavController,
    public user: User, public viewCtrl: ViewController, public alertCtrl: AlertController, public formBuilder: FormBuilder,public navParams: NavParams,public items: Items) {
    //let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    let EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.getPractices();
    this.getGroupings();
    let DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
    this.form = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      parent_1_name: ['', Validators.required],
      email: ['', Validators.compose([Validators.pattern(EMAIL_REGEXP), Validators.required])],
      parent_2_name: [''],
      parent_2_email: ['', Validators.compose([Validators.pattern(EMAIL_REGEXP)])],
      client_key: [''],
      date_of_birth: ['',Validators.compose([Validators.maxLength(10), Validators.pattern(DATE_REGEXP)])],
      sex_id: ['3', Validators.required],
      inactive: ['0', Validators.required],
      assigned_users:[['']],
      assigned_groups:[['']]
    });
    //the below code to have the data prepopulated can also be done using
    //new FormControl(field.fieldValue || '', [Validators.required, this.NoWhitespaceValidator])
    console.log('asd');
    console.log(this.navParams.data.client);
    this.current = null
    if (this.navParams.data.client) {
      this.current = this.navParams.data.client
      this.isEditClient = true;
      this.form.setValue({
        first_name: this.navParams.data.client.first_name, 
        last_name: this.navParams.data.client.last_name,
        parent_1_name:this.navParams.data.client.parent_1_name,
        email:this.navParams.data.client.email,
        parent_2_name:this.navParams.data.client.parent_2_name,
        parent_2_email:this.navParams.data.client.parent_2_email,
        date_of_birth:moment(this.navParams.data.client.date_of_birth, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        client_key:this.navParams.data.client.client_key,
        sex_id:this.navParams.data.client.sex_id,
        inactive:this.navParams.data.client.inactive,
        assigned_users:this.navParams.data.client.assigned_users,
        assigned_groups:this.navParams.data.client.assigned_groups
      });
    }
      // Watch the form for changes, and
      this.form.valueChanges.map((val) => {
        // remove the trailing spaces from first name and last name
        val.first_name = val.first_name.trim();
        val.last_name = val.last_name.trim();
        return val;
    })
      .subscribe((val) => {
        this.isReadyToSave = this.form.valid;
      });
    
  }

  ionViewDidLoad() {
    // if (this.navParams.data.client) {
    //   for (let i = 0; i < this.navParams.data.client.assigned_users.length; i++) {
    //     var assigned_usersId = this.navParams.data.client.assigned_users[i];
    //     var assignedUser = this.getAssignedUserForId(assigned_usersId);
    //     this.assignedUserSelected(assignedUser);
    //   }
    // }
  }

  getAssignedUserForId(assigned_usersId: any){
    if(this.practices){
      return this.practices.find(x => x.id == assigned_usersId);
    }
  }

  assignedUserSelected(param: any){
    if(param){
      param.selected = true;
    }
    
  }

  getGroupings() {
    this.groupings_array = [];
    this.groupSelected = [];
    let selected = [];
    this.items.getGroupings().subscribe(res => {
      if (res) {
        this.groupings = res;

        if (this.groupings.length > 0) {
          this.showClientGroups = true;

          this.groupings.forEach(item => {
            let grp = {
              id: item.Grouping.id,
              name: item.Grouping.name
            };

            this.groupings_array.push(grp);

  
            if (this.navParams.data.client) {
              if (this.navParams.data.client.assigned_groups.includes(item.Grouping.id)) {
                selected.push(grp);
                this.groupSelected.push(item.Grouping.id);
              }
            }
          });

          this.form.controls.assigned_groups.setValue(selected);
        }
      }
    },
      err => {
        console.log(err);
      });
  }

  getPractices(){
    this.practices_array = [];
    this.userSelected = [];
    let selected = [];
    if (this.navParams.data.userData.usertype_id == '3') {
      this.isVisible = false;
      return;
    }
    this.user.getPractices().subscribe(res => {
      if(res){
        localStorage.setItem('practiceData', JSON.stringify(res));
        this.practiceData = <Practice>JSON.parse(localStorage.getItem('practiceData'));
        if(this.practiceData){
          this.practices = this.practiceData.users;

          if (this.practices.length > 1) {
            this.showClientUsers = true;

            this.practices.forEach(item => {
              let grp = {
                id: item.id,
                name: item.name
              };
  
              this.practices_array.push(grp);
  
              if (this.navParams.data.client) {
                if (this.navParams.data.client.assigned_users.includes(item.id)) {
                  selected.push(grp);
                  this.userSelected.push(item.id);
                }
              }
            });
  
            this.form.controls.assigned_users.setValue(selected);
          }
    
          if(this.navParams.data.userData.usertype_id == '2' || (this.navParams.data.userData.usertype_id == '1' && this.practices.length > 0)){
            this.isVisible = true;
          }
        }else{
          this.isVisible = false;
        }
      }
    },
      err => {
        console.error('ERROR', err);
        this.isVisible = false;
      });
  }

  groupChange(event: {
    component: IonicSelectableModule,
    value: any
  }) {
    let selected = [];
    console.log('port:', event.value);
    event.value.forEach(function (item) {
      if (item.id) {
        selected.push(item.id);
      }
    });

    this.groupSelected = selected;
  }

  userChange(event: {
    component: IonicSelectableModule,
    value: any
  }) {
    let selected = [];
    console.log('port:', event.value);
    event.value.forEach(function (item) {
      if (item.id) {
        selected.push(item.id);
      }
    });

    this.userSelected = selected;
  }  

  emailOrEmpty(control: AbstractControl): ValidationErrors | null {
    return control.value === '' ? null : Validators.email(control);
}

  deleteClient(){
    let prompt = this.alertCtrl.create({
      message: "Are you sure you want to delete this client? This cannot be undone. Instead, it is recommended that you mark them as inactive. Note, deleting clients does not reduce your overall client count.",
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
          }
        },
        {
          text: 'Mark as Inactive',
          handler: data => {
            this.viewCtrl.dismiss({form: null, dismiss:'inactive'});
          }
        },
        {
          text: 'Delete',
          handler: data => {
            this.viewCtrl.dismiss({form: null, dismiss:'delete'});
          }
        }
      ]
    });
    prompt.present();
    // if (!this.form.valid) { return; }
  }

  /**
   * The user cancelled, so we dismiss without sending data back.
   */
  cancel() {
    this.viewCtrl.dismiss({form: null, dismiss:'cancel'});
  }
  /**
   * The user is done and wants to create the item, so return it
   * back to the presenter.
   */
  done() {
    if (this.showClientGroups) {
      this.form.controls.assigned_groups.setValue(this.groupSelected);
      console.log(this.form.controls.assigned_groups);
    }
    
    if (this.isVisible && this.showClientUsers) {
      this.form.controls.assigned_users.setValue(this.userSelected);
      console.log(this.form.controls.assigned_users);
    }
    console.log(this.form.controls);

    if (!this.form.valid) { return; }
    this.form.value.date_of_birth = moment(this.form.value.date_of_birth, 'DD/MM/YYYY').format('YYYY-MM-DD');
    this.viewCtrl.dismiss({form: this.form.value, dismiss:'done'});
  }

  static datePattern(c: FormControl) {
    const dateRegEx = new RegExp(/^\d{1,2}\.\d{1,2}\.\d{4}$/);
    return dateRegEx.test(c.value) ? null : {date: true}
  }
}



// WEBPACK FOOTER //
// ./src/pages/client-create/client-create.ts